import React from "react";
import { ProductPageSection } from "components/templates/ProductPage/ProductPageSection";
import { FAQS } from "components/molecules/FAQ";
import { IProduct } from "interfaces/product.interface";

export const ProductPageFAQs = ({ product }: { product: IProduct }) => {
  return (
    <ProductPageSection id="faqs" title="Questions &amp; answers">
      <FAQS faqs={product.faqs} />
    </ProductPageSection>
  );
};
